<template>
	<div class="wrapper">
		<div v-if="loading" class="text-center">
			<b-spinner label="Loading..." style="width: 3rem; height: 3rem;" variant="info"></b-spinner>
		</div>
		<div v-else class="animated fadeIn">
			<b-row>
				<b-col cols="12">
					<div>
						<genericTable :table-data="tableData" :filter="true" :fields="fields" :per-page=25 hover striped bordered small
													caption="<i class='icon-list'></i> List of Companies">
							<template v-slot:actions>
								<b-nav pills small class="float-right" v-if="$store.getters.canWrite">
									<b-nav-item active v-b-modal.company-composer><i class="fa fa-plus"></i> Add Company</b-nav-item>
								</b-nav>
							</template>
							<template v-slot:row-actions="row">
								<b-button v-if="$store.getters.canWrite" size="sm" variant="danger" class="mr-1" @click="editCompany(row.row.item.id)">
									<i class="icon-pencil"></i> Edit
								</b-button>
							</template>
						</genericTable>
					</div>
				</b-col>
			</b-row>
		</div>
		<b-modal id="company-composer"
						 title="Add New Company"
						 ok-title="Save"
						 @ok="handleOk"
						 @cancel="resetForm">
			<b-form @submit.prevent="checkFormValidity()" method="post">
				<b-form-group
					label="Name"
					label-for="name"
					label-class="required"
					:label-cols="4"
					:horizontal="true">
					<b-form-input v-model="form.name" name="name" id="name" type="text" placeholder="Name" :state="$v.form.name.$dirty ? !$v.form.name.$error : null" aria-describedby="name-live-feedback"></b-form-input>
					<b-form-invalid-feedback id="name-live-feedback">This is a required field and must not be blank.</b-form-invalid-feedback>
				</b-form-group>
				<b-form-group
					label="Client Panel Title"
					label-for="title"
					label-class="required"
					:label-cols="4"
					:horizontal="true">
					<b-form-input v-model="form.title" name="title" id="title" type="text" placeholder="Title" :state="$v.form.title.$dirty ? !$v.form.title.$error : null" aria-describedby="title-live-feedback"></b-form-input>
					<b-form-invalid-feedback id="title-live-feedback">This is a required field and must not be blank.</b-form-invalid-feedback>
				</b-form-group>
				<b-form-group
					label="Company Group"
					label-for="companyGroup"
					label-class="required"
					:label-cols="4"
					:horizontal="true">
					<b-form-select v-model="form.companyGroupId"
												 name="companyGroup"
												 id="companyGroup"
												 :plain="true"
												 :options="companyGroupDropDownList"
												 value="Please Select"
												 :state="$v.form.companyGroupId.$dirty ? !$v.form.companyGroupId.$error : null"
												 aria-describedby="company-group-live-feedback">
					</b-form-select>
					<b-form-invalid-feedback id="company-group-live-feedback">Please select one.</b-form-invalid-feedback>
				</b-form-group>
			</b-form>
		</b-modal>
	</div>
</template>

<script>
import genericTable from "@/components/GenericTable";
import companyService from '@/services/companyService';
import toastService from "@/services/toastService";
import companyGroupService from "@/services/companyGroupService";
import { required, minValue } from 'vuelidate/lib/validators';

export default {
	name : "CompanyList",
	components : {
		"genericTable" : genericTable
	},
	data: () => {
		return {
			companyList: [],
			fields: [
				{key: 'id', label: 'ID', sortable: true},
				{key: 'name', label: 'Name', sortable: true, searchable:true},
				{key: 'cp_title', label: 'CP Title', sortable: true, searchable:true},
				{key: 'group_name', label: 'Group Name', sortable: true, searchable:true},
				{key: 'status', label : 'Status'},
				{key: 'actions', label: 'Actions'},
				{key: 'loginEnabled', label: 'Login Enabled'}
			],
			form: {
				name: null,
				title: null,
				companyGroupId: null
			},
			companyGroupDropDownList: [
				{text: 'Please Select', value: null},
			],
			loading: false
		}
	},
	validations: {
		form: {
			name: {
				required
			},
			title: {
				required
			},
			companyGroupId: {
				required,
				minValue: minValue(1)
			}
		}
	},
	methods: {
		getCompanyList: function () {
			this.loading = true
			companyService.getAllCompanies((data) =>{
				this.createCompanyListTable(data);
				this.getAllCompanyGroups();
				this.loading = false;
			}, (error) =>{
				toastService.showErrorToast("Could not fetch company list " + error);
				this.loading = false;
			});
		},
		getAllCompanyGroups: function () {
			companyGroupService.getAllCompanyGroups((data) => {
				this.createCompanyGroupDropDownList(data);
			}, (error) => {
				toastService.showErrorToast("Could not fetch group of companies list " + error);
			});
		},
		createCompanyGroupDropDownList: function (data) {
			data.forEach((item) => {
				let companyGroup = new Object();
				companyGroup.text = item.name;
				companyGroup.value = item.id;
				this.companyGroupDropDownList.push(companyGroup);
			});
		},
		createCompanyListTable: function (data){
			data.forEach((value) => {
				let row = new Object();
				row.id = value.id;
				row.name = value.name;
				row.cp_title = value.clientPanelTitle;
				row.group_name = value.groupName;
				row.status = value.status;
				row.loginEnabled = value.loginEnabled;
				this.companyList.push(row);
			});
		},
		createCompany: function () {
			const formData = {
				name: this.form.name,
				clientPanelTitle: this.form.title,
				groupId: this.form.companyGroupId
			};

			companyService.createNewCompany(formData, (data) => {
				this.companyList = [];
				this.createCompanyListTable(data);
				this.resetForm();
				toastService.showSuccessToast("Company created successfully");
			}, (error) => {
				this.$nextTick(() => { this.$v.$reset() });
				toastService.showErrorToast("Could not create new company " + error);
			});
		},
		resetForm: function () {
			this.$nextTick(() => {
				this.$v.$reset();
				this.$bvModal.hide("company-composer");
			});
			this.form.name = null;
			this.form.title = null;
			this.form.companyGroupId = null;
		},
		editCompany: function (companyId) {
			this.$router.push("companies/" + companyId);
		},
		handleOk(event) {
			event.preventDefault();
			switch (event.componentId) {
				case "company-composer" :
					this.checkFormValidity();
					break;
			}
		},
		checkFormValidity: function (){
			let formHasErrors = false;

			this.$v.form.$touch();
			if (this.$v.form.$anyError) {
				formHasErrors = true;
			}

			if(formHasErrors) return;
			else this.createCompany();
		}
	},
	created() {
		this.getCompanyList();
	},
	computed: {
		tableData : function(){
			return this.companyList;
		}
	}
}
</script>

<style scoped>

</style>
